import { render } from "./RequestInvestigation.vue?vue&type=template&id=02460758&scoped=true"
import script from "./RequestInvestigation.vue?vue&type=script&lang=js"
export * from "./RequestInvestigation.vue?vue&type=script&lang=js"

import "./RequestInvestigation.vue?vue&type=style&index=0&id=02460758&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02460758"]])

export default __exports__